import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { environment } from '@ion/env';

@Injectable({ providedIn: 'root' })
export class DomainContextService {
  private readonly document = inject(DOCUMENT);

  /**
   * Checks if the current domain is a fleet domain.
   *
   * @returns true when the domain is fleet
   */
  isFleetsDomain(): boolean {
    return this.document.location.hostname.toLowerCase().startsWith(environment.fleetsDomain.toLowerCase());
  }
}
